angular.module("vgresiduos").controller("mtrExemptionCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/integracoes/desobrigacao-mtr/novo", []);
		};
	}
]);
